import React, { useContext, useEffect, useState } from "react";
import { Box, Fade, Grid, Grow, Link, Stack, Tooltip, Typography } from "@mui/material";
import PlayerMatchHistory from "../../../../components/datagrids/Competitive/PlayerHistory";
import PlayerChampions from "../../../../components/datagrids/Competitive/PlayerChampions";
import global_context from "../../../../static_vars";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel, { a11yProps } from "../../../../components/tabs_switch/tabs_panel";
import YearSelect, { PhaseSelect, SplitSelect } from "../../../../components/selectors/PeriodSelect";
import CompetitivePlayerEvolution from "../../../../components/Charts/CompetitivePlayerEvolution";
import FarsightApi from "../../../../ApiWrapper";
import PlayerPresentation from "../../../../components/visu_blocks/PlayerPresentation";
import StatRow from "../../../../components/visu_blocks/StatRow";
import VariableDistribution from "../../../../components/Charts/VariableDistribution";
import ChampionsPie from "../../../../components/Charts/ChampionsPie";
import Button from "@mui/material/Button";

export default function PlayersDetails() {
    const context = useContext(global_context);

    const [state, setState] = useState({
        year: context.state.current_year,
        split: context.state.current_split,
        phase: context.state.current_phase,
        leagues: context.state.current_leagues.map((league: any) => league.league_name),
        champions: context.state.current_champions,
        player: context.state.current_player,
        metrics: context.state.current_metrics,
        tab: 0,
    });

    const handleLeagueChange = (event: any, newValue: string[]) => {
        setState({ ...state, leagues: newValue });
    };
    const handleMetricsChange = (event: any, newValue: string[]) => {
        setState({ ...state, metrics: newValue });
    };

    const handleChampionChange = (event: any, newValue: any) => {
        setState({ ...state, champions: newValue });
    };
    const handlePlayerChange = (event: any, newValue: string) => {
        setState({ ...state, player: newValue });
    };
    const handleTabChange = (event: any, newValue: number) => {
        setState({
            ...state,
            tab: newValue,
        });
    };

    const handleYearChange = (event: any, newValue: number) => {
        setState({ ...state, year: newValue });
    };

    const handleSplitChange = (event: any) => {
        setState({ ...state, split: event.target.value });
    };

    const handlePhaseChange = (event: any) => {
        setState({ ...state, phase: event.target.value });
    };

    return (
        <Grid
            container
            sx={{
                ml: "100px",
                width: window.innerWidth - 200 + "px",
                height: window.innerHeight - 220 + "px",
            }}
        >
            <Stack
                direction={"column"}
                spacing={1}
                sx={{
                    m: 1,
                    height: "100%",
                    width: "100%",
                    mt: 5,
                    alignItems: "top",
                    display: "flex",
                }}
            >
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                    <Stack direction={"row"} spacing={1} sx={{ m: 1, height: "75px", width: "100%" }}>
                        {/*<PlayerSelect getValue={state.player} onChange={handlePlayerChange} />*/}
                        {/*<LeaguesSelect getValue={state.leagues} onChange={handleLeagueChange}/>*/}
                        <YearSelect value={state.year} onChange={handleYearChange} />
                        <SplitSelect value={state.split} onChange={handleSplitChange} />
                        <PhaseSelect value={state.phase} onChange={handlePhaseChange} />
                        {/*<MultipleChampionSelect getValue={state.champions} onChange={handleChampionChange}/>*/}
                    </Stack>
                </Grow>
                {/*<FilterSet paramObject={paramObject} setParamObject={setParamObject} target={props.target}*/}
                {/*           player={player} setPlayer={setPlayer}*/}
                {/*           split={split} setSplit={setSplit}*/}
                {/*           phases={phases} setPhases={setPhases}*/}
                {/*></FilterSet>*/}
                <Grow in={true} style={{ transformOrigin: "0 -50 0" }} {...{ timeout: 2000 }}>
                    <Tabs value={state.tab} aria-label="basic tabs example" onChange={handleTabChange}>
                        <Tab label="Overview" {...a11yProps(0)} />
                        <Tab label="Champions" {...a11yProps(1)} />
                        <Tab label="History" {...a11yProps(2)} />
                        <Tab label="Evolution" {...a11yProps(3)} />
                    </Tabs>
                </Grow>
                {state.tab !== 0 && state.tab !== 3 ? (
                    <Stack direction={"row"} spacing={1} sx={{ m: 1, height: "75px", width: "100%" }}>
                        <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                            <Box>{/*<MultipleMetricsSelect getValue={state.metrics} onChange={handleMetricsChange} target={'competitive'}/>*/}</Box>
                        </Grow>
                    </Stack>
                ) : (
                    <></>
                )}
                <TabPanel value={state.tab} index={0}>
                    <Stack direction={"row"} sx={{ height: window.innerHeight - 300 + "px", mt: 3 }}>
                        <CompetitivePlayerOverview year={state.year} split={state.split} phase={state.phase} champions={state.champions} leagues={state.leagues} player={state.player.player} target={"competitive"} />
                    </Stack>
                </TabPanel>
                <TabPanel value={state.tab} index={1}>
                    <Grid sx={{ height: window.innerHeight - 350 + "px" }}>
                        <PlayerChampions year={state.year} split={state.split} phase={state.phase} champions={state.champions} leagues={state.leagues} player={state.player.player} target={"competitive"} metrics={state.metrics} detailed={true} />
                    </Grid>
                </TabPanel>
                <TabPanel value={state.tab} index={2}>
                    <Grid sx={{ height: window.innerHeight - 350 + "px" }}>
                        <PlayerMatchHistory year={state.year} split={state.split} phase={state.phase} leagues={state.leagues} player={state.player.player} target={"competitive"} metrics={state.metrics} detailed={true} />
                    </Grid>
                </TabPanel>
                <TabPanel value={state.tab} index={3}>
                    <Grid sx={{ height: window.innerHeight - 340 + "px" }}>
                        <CompetitivePlayerEvolution player={state.player.player} year={state.year} />
                    </Grid>
                </TabPanel>
            </Stack>
        </Grid>
    );
}

function CompetitivePlayerOverview(props: any) {
    return (
        <Stack
            component={"fieldset"}
            direction={"row"}
            sx={{
                borderRadius: 3,
                height: window.innerHeight - 300 + "px",
                justifyContent: "space-evenly",
                width: "100%",
                alignItems: "center",
                m: 1,
            }}
            spacing={3}
        >
            <PlayerPresentation player={props.player} />
            <CompetitivePlayerStats {...props} />
            <Grow in={true} style={{ transformOrigin: "0 100 0" }} {...{ timeout: 4000 }}>
                <Stack
                    direction={"column"}
                    sx={{
                        height: "100%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-around",
                    }}
                >
                    <VariableDistribution {...props} bucket_size={20} metric={"performance"} label={"Perf."} min={-250} max={250} />
                    <VariableDistribution {...props} bucket_size={20} metric={"relative_performance"} label={"RPerf."} min={-250} max={250} />
                </Stack>
            </Grow>
            <Grow in={true} style={{ transformOrigin: "0 100 0" }} {...{ timeout: 4000 }}>
                <Stack
                    direction={"column"}
                    sx={{
                        height: "100%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-around",
                    }}
                >
                    <ChampionsPie {...props} />
                </Stack>
            </Grow>
        </Stack>
    );
}

export function CompetitivePlayerStats(props: any) {
    const [data, setData] = useState(undefined as any);
    const [reload, setReload] = useState(true);
    let props_copy: any = JSON.parse(JSON.stringify(props));
    props_copy.metrics = ["games", "winrate", "kda", "cspm", "performance", "relative_performance", "gd15", "xpd15", "csd15", "dpm", "gpm", "cp_frequency"];
    props_copy.groupby = "player";

    useEffect(() => {
        setReload(false);
        setData(undefined);
        FarsightApi.get_request("StatsOverview", props_copy)
            .then((r) => {
                setData(r);
            })
            .then(() => setReload(true));
    }, [props]);
    return data && data.player ? (
        <Stack
            direction={"column"}
            sx={{
                height: "100%",
                justifyContent: "space-evenly",
                alignItems: "center",
                display: "flex",
                width: "230px",
            }}
            spacing={2}
        >
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                    <Button
                        variant={"outlined"}
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                        }}
                        onClick={() =>
                            navigator.clipboard.writeText(
                                `${Math.round(data["performance"] * 100) / 100}\t${Math.round(data["relative_performance"] * 100) / 100}\t${data["games"]}\t${data["winrate"].toLocaleString("en", {
                                    style: "percent",
                                })}`.replaceAll(".", ","),
                            )
                        }
                    >
                        {"Competitive Stats"}
                    </Button>
                </Grow>
                <StatRow stat={"Nb. Games"} value={data["games"]} />
                <StatRow
                    stat={"WR"}
                    value={data["winrate"].toLocaleString("en", {
                        style: "percent",
                    })}
                />
                <StatRow stat={"Perf."} value={Math.round(data["performance"] * 100) / 100} />
                <StatRow stat={"RPerf."} value={Math.round(data["relative_performance"] * 100) / 100} />
                {/*<StatRow stat={'CP%'} getValue={data['cp_frequency'].toLocaleString("en", {style: "percent"})}/>*/}
            </Stack>
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 3000 }}>
                    <Typography
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                            outline: "1px solid white",
                        }}
                    >
                        {"In Game"}
                    </Typography>
                </Grow>
                <StatRow stat={"KDA"} value={Math.round(data["kda"] * 100) / 100} />
                <StatRow stat={"DPM"} value={Math.round(data["dpm"] * 100) / 100} />
                <StatRow stat={"CSPM"} value={Math.round(data["cspm"] * 100) / 100} />
                <StatRow stat={"GPM"} value={Math.round(data["gpm"] * 100) / 100} />
            </Stack>
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 4000 }}>
                    <Typography
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                            outline: "1px solid white",
                        }}
                    >
                        {"Laning"}
                    </Typography>
                </Grow>
                <StatRow stat={"GD@15"} value={Math.round(data["gd15"] * 100) / 100} />
                <StatRow stat={"XPD@15"} value={Math.round(data["xpd15"] * 100) / 100} />
                <StatRow stat={"CSD@15"} value={Math.round(data["csd15"] * 100) / 100} />
            </Stack>
        </Stack>
    ) : (
        <Box sx={{ width: "230px", textJustify: "center", textAlign: "center" }}>{`No ${props.player} games for selected preset`}</Box>
    );
}
